// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2mtsg","consentsList":"PatientConsents_consentsList__wGvGM","consentsListEmpty":"PatientConsents_consentsListEmpty__2d49u"};